module.exports = __webpack_public_path__ + "img/background.07a88ed0.png";